/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Parcels_EmptyInputs */

const vi_care_log_parcels_empty = /** @type {(inputs: Care_Log_Parcels_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hộ trồng chè này chưa có vùng trồng nào`)
};

/**

* @param {Care_Log_Parcels_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_parcels_empty = /** @type {((inputs?: Care_Log_Parcels_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Parcels_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_parcels_empty(inputs)
});